import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';

const ZipCodeInput = ({ control, name, label, required, error, helperText }) => {
  const formatZipCode = (value) => {
    if (!value) return value;
    
    const onlyNums = value.replace(/\D/g, '');
    if (onlyNums.length <= 5) return onlyNums;
    return `${onlyNums.slice(0, 5)}-${onlyNums.slice(5, 8)}`;
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{ 
        required: required && 'Campo obrigatório',
        pattern: {
          value: /^\d{5}-?\d{3}$/,
          message: 'CEP inválido (formato: 00000-000)'
        }
      }}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label={label}
          fullWidth
          error={error || !!fieldState.error}
          helperText={fieldState.error?.message || helperText}
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {
            field.onChange(formatZipCode(e.target.value));
          }}
          inputProps={{
            maxLength: 9
          }}
        />
      )}
    />
  );
};

ZipCodeInput.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string
};

export default ZipCodeInput;